import * as React from "react";
import {Button} from "primereact/button";
import "./ButtonInput.scss";

type ButtonPositionType = 'left' | 'right' | undefined;

export interface ButtonInputWithIconProps {
    labelText: string;
    onButtonClick: () => void;
    addStyle?: React.CSSProperties;
    icon?: string;
    iconAlign?: ButtonPositionType;
    disabled?: boolean;
};

export const ButtonInput = (p: ButtonInputWithIconProps) => {
    const {
        onButtonClick,
        labelText,
        addStyle,
        icon,
        iconAlign,
        disabled
    } = p;

    return (
        <div className="button-input-with-icon">
            <Button
                id='buttonInputWithIconId'
                label={labelText}
                onClick={onButtonClick}
                icon={icon}
                iconPos={iconAlign}
                style={addStyle}
                disabled={disabled}
            />
        </div>
    );
};
